import React, { createContext, useState } from 'react';

export const HRAdminCompanyContext = createContext();

// * This is used for selecting company in HR Admin side and sharing that selection with all screens 
export const HRAdminCompanyContextProvider = ({ children }) => {
    const [selectedCompany, setSelectedCompany] = useState({ code: undefined, description: undefined });
    const [companyOptions, setCompanyOptions] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(undefined);
    const [selectedCompanyCode, setSelectedCompanyCode] = useState(undefined);

    return (
        <HRAdminCompanyContext.Provider value={{ selectedCompany, setSelectedCompany, selectedEmployee, setSelectedEmployee, companyOptions, setCompanyOptions, selectedCompanyCode, setSelectedCompanyCode }}>
            {children}
        </HRAdminCompanyContext.Provider>
    );
};